module.exports = "mat-chip {\n  text-align: center; }\n"